import { HSL, RGB } from './types';

// Code from
// https://css-tricks.com/converting-color-spaces-in-javascript/

const convertHSLtoRGB = (hsl: HSL): { rgb: string } & RGB => {
  if (hsl.h < 0 || hsl.h > 360) {
    throw new Error('h must be >=0 && <=360');
  }
  if (hsl.s < 0 || hsl.s > 100) {
    throw new Error('s must be >=0 && <=100');
  }
  if (hsl.l < 0 || hsl.l > 100) {
    throw new Error('l must be >=0 && <=100');
  }

  const { h } = hsl;
  const s = hsl.s / 100;
  const l = hsl.l / 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;

  if (0 <= h && h < 60) {
    r = c;
    g = x;
    b = 0;
  } else if (60 <= h && h < 120) {
    r = x;
    g = c;
    b = 0;
  } else if (120 <= h && h < 180) {
    r = 0;
    g = c;
    b = x;
  } else if (180 <= h && h < 240) {
    r = 0;
    g = x;
    b = c;
  } else if (240 <= h && h < 300) {
    r = x;
    g = 0;
    b = c;
  } else if (300 <= h && h < 360) {
    r = c;
    g = 0;
    b = x;
  }

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return {
    rgb: `rgb(${r}, ${g}, ${b})`,
    r,
    g,
    b,
  };
};

export default convertHSLtoRGB;
